// extracted by mini-css-extract-plugin
export var gif = "_bw-0";